import { useEffect, useRef, useState } from "react";
import { MdDelete, MdEdit } from "react-icons/md";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { ChangeStatus } from "../../Components";
import Loader from "../../Components/Loader";
import CheckAccess from "../../Function/CheckAccess";
import { creditNoteService } from "../../Services";

let currentPage1 = 1;

export const CreditNoteList = () => {
  const history = useHistory();
  const imgRef = useRef();
  let user_type = localStorage.getItem("user_type");
  const [creditList, setCreditList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteModalData, setDeleteModalData] = useState("");
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    getCreditList();
  }, [currentPage]);

  const getCreditList = () => {
    let param = { ...pagination, page: currentPage };
    if (pagination.search) {
      param["search"] = pagination.search;
      param["page"] = 1;
    }
    creditNoteService.getCreditList(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setCreditList(res.data);
        setPagination({ ...pagination, ...res.pagination });
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      id: isModalOpen._id,
      status: isModalOpen.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    creditNoteService.update_vendor_status(postData).then((res) => {
      if (res.status) {
        setIsModalOpen(false);
        getCreditList();
      }
    });
  };

  const handleDeleteModal = async (item) => {
    setDeleteModalData(item);
    setDeleteModalOpen(true);
  };

  const onDeleteSubmit = () => {
    let postData = {
      Id: deleteModalData?.credit_note?.CreditMemo?.Id,
    };
    let postData2 = {
      credit_note_amount: deleteModalData?.amount,
      job_id: deleteModalData?.job_id,
    };
    creditNoteService.deleteCreditNote(postData).then((result) => {
      if (result.status) {
        creditNoteService.creditNoteDelete(postData2).then((res) => {
          if (res.status) {
            setLoader(false);
            history.goBack();
          } else {
            setLoader(false);
            toast.error(res.message);
          }
        });
      } else {
        setLoader(false);
      }
    });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1;
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="input-group pl-3 w-25">
                <input
                  className="form-control"
                  type="text"
                  placeholder="search..."
                  onChange={(e) =>
                    setPagination({ ...pagination, search: e.target.value })
                  }
                  onKeyPress={(e) => e.key === "Enter" && getCreditList()}
                  onKeyUp={(e) =>
                    e.key === "Backspace" &&
                    pagination.search.length <= 0 &&
                    getCreditList()
                  }
                ></input>
                <div className="input-group-prepend">
                  <button
                    className="input-group-text pointer search-btn"
                    onClick={() => getCreditList()}
                    style={{ backgroundColor: "#e5e4ec" }}
                  >
                    search
                  </button>
                </div>
              </div>
              {(CheckAccess(424, "add") || user_type === "SUPERADMIN") && (
                <button
                  className="btn btn-primary w-sm waves-effect waves-light mx-3"
                  onClick={() => history.push("/add-credit-note")}
                >
                  Add Credit Note
                </button>
              )}
              <input ref={imgRef} type="file" className="d-none" />
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Job Token</th>
                    <th>Credit No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Comment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {creditList.length > 0 &&
                    creditList.map((item, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td>{item.job_token}</td>
                        <td>{item.credit_note.CreditMemo.DocNumber}</td>
                        <td>{item.user_name}</td>
                        <td>{item.user_email}</td>
                        <td>{item.amount}</td>
                        <td>{item.credit_date.substring(0, 10)}</td>
                        <td>{item.comment}</td>
                        <td>
                          <MdEdit
                            className="pointer ms-1"
                            onClick={() =>
                              history.push("/edit-credit-note?id=" + item._id ,item)
                            }
                            color="#0323fe"
                            size="25px"
                          />

                          <MdDelete
                            className="pointer text-danger ms-1"
                            onClick={() => handleDeleteModal(item)}
                            size="25px"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {creditList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {creditList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src="assets/images/prev.svg"
                    height={15}
                    alt="not found"
                  />
                }
                forcePage={currentPage - 1}
                nextLabel={
                  <img
                    src="assets/images/next.svg"
                    height={15}
                    alt="not found"
                  />
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          <Loader isShow={loader} />
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${
              isModalOpen.status === "ACTIVE" ? "Inactive" : "Active"
            } status ?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}

        {Boolean(deleteModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(deleteModalOpen)}
            title="Delete"
            message={`Are you sure want to delete?`}
            onSubmitEvent={() => onDeleteSubmit()}
            handleClose={() => setDeleteModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
